import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import ProfessionalSearch from '../components/Professional/ProfessionalSearch';
import { getProfessionals } from '../services/professionalService';
import EnhancedInvitationModal from '../components/Professional/EnhancedInvitationModal';

const ProfessionalDiscovery = () => {
  const navigate = useNavigate();
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Enhanced invitation modal
  const [enhancedInvitationModal, setEnhancedInvitationModal] = useState(false);
  const [selectedProfessionalForInvitation, setSelectedProfessionalForInvitation] = useState(null);

  // Load professionals - memoized to prevent infinite loop
  const handleLoadProfessionals = useCallback(async (filters) => {
    try {
      setLoading(true);
      const data = await getProfessionals(filters);
      console.log('[ProfessionalDiscovery] Received data:', data);
      console.log('[ProfessionalDiscovery] Professionals array:', data?.professionals);
      // getProfessionals returns { professionals: [...] }
      const profArray = data?.professionals || [];
      console.log('[ProfessionalDiscovery] Setting professionals:', profArray);
      setProfessionals(profArray);
    } catch (error) {
      console.error('[ProfessionalDiscovery] Error loading professionals:', error);
      setSnackbar({
        open: true,
        message: 'Failed to load professionals. Please try again.',
        severity: 'error'
      });
      setProfessionals([]);
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array - function doesn't depend on any props/state

  // Check if user is logged in
  const checkUserLoggedIn = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setSnackbar({
        open: true,
        message: 'Please log in to continue',
        severity: 'warning'
      });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
      return false;
    }
    return true;
  };

  // Handle sending invitation - memoized
  const handleSendInvitation = useCallback((professional) => {
    if (!checkUserLoggedIn()) return;

    setSelectedProfessionalForInvitation(professional);
    setEnhancedInvitationModal(true);
  }, [navigate]);

  const handleCloseEnhancedInvitation = () => {
    setEnhancedInvitationModal(false);
    setSelectedProfessionalForInvitation(null);
  };

  const handleEnhancedInvitationSuccess = (paymentData) => {
    setSnackbar({
      open: true,
      message: 'Invitation sent successfully! Payment has been pre-authorized, waiting for professional response.',
      severity: 'success'
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <ProfessionalSearch
        professionals={professionals}
        loading={loading}
        onSendInvitation={handleSendInvitation}
        onLoadProfessionals={handleLoadProfessionals}
      />

      {/* Enhanced Invitation Modal */}
      {selectedProfessionalForInvitation && (
        <EnhancedInvitationModal
          open={enhancedInvitationModal}
          onClose={handleCloseEnhancedInvitation}
          professional={selectedProfessionalForInvitation}
          onSuccess={handleEnhancedInvitationSuccess}
        />
      )}

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProfessionalDiscovery;
